/**
 * The mission runtime's only clock.
 *
 * Every wait in the runtime — the 8/15/25 s timer ladder, the portal dwell, the count settle
 * window, the teaching-moment cap — goes through here rather than calling `setTimeout` directly.
 * Two reasons, and neither is testing convenience alone:
 *
 *   - pausing a mission has to genuinely stop time. A parent who pauses at 7 s must not come back
 *     to a round that has already escalated to teaching.
 *   - a 25 s ladder asserted against a real clock is a 25 s test, and a test that slow gets
 *     deleted rather than maintained.
 */

export type TimerHandle = number;

export interface Scheduler {
  now(): number;
  setTimeout(callback: () => void, delayMs: number): TimerHandle;
  clearTimeout(handle: TimerHandle): void;
}

export function createSystemScheduler(): Scheduler {
  return {
    now: () => Date.now(),
    setTimeout: (callback, delayMs) => setTimeout(callback, delayMs) as unknown as TimerHandle,
    clearTimeout: (handle) => {
      clearTimeout(handle as unknown as ReturnType<typeof setTimeout>);
    },
  };
}
